export const isFreeTx = (transaction) => {
  return transaction?.paid_amount === 0;
};

export const getTxStatusText = (transaction) => {
  if (!transaction) return '-';

  const statusMap = {
    ready: '결제대기',
    paid: '결제',
    partial_cancelled: '부분환불',
    cancelled: isFreeTx(transaction) ? '취소' : '환불',
  };

  return statusMap[transaction.status] || '-';
};
